
import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { PriceData } from '@/utils/excelUtils';

interface PricingTableProps {
  priceData: PriceData[];
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

const PricingTable = ({ priceData, searchTerm }: PricingTableProps) => {
  // Check if priceData array is valid
  if (!Array.isArray(priceData)) {
    console.error("PricingTable received invalid priceData:", priceData);
    return (
      <div className="p-4 text-center text-red-500">
        Error: Invalid pricing data format
      </div>
    );
  }

  // Check if productName or productId fields are swapped or missing
  const hasCorrectFields = priceData.length > 0 && 
    priceData.every(item => 
      typeof item.productName === 'string' && 
      typeof item.productId === 'string'
    );
  
  // If fields are swapped, log debugging info
  if (priceData.length > 0 && !hasCorrectFields) {
    console.error("Potential data field issue:", priceData[0]);
  }

  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Product Name</TableHead>
            <TableHead>Product Description</TableHead>
            <TableHead>MSRP</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {priceData.length > 0 ? (
            priceData.map((item, index) => (
              <TableRow key={`${item.productId || ''}-${index}`}>
                <TableCell>{item.productName || 'N/A'}</TableCell>
                <TableCell>{item.productId || 'N/A'}</TableCell>
                <TableCell>{item.msrp ? (item.msrp.startsWith('$') ? item.msrp : `$${item.msrp}`) : 'N/A'}</TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={3} className="text-center py-4 text-muted-foreground">
                No results match your search
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default PricingTable;
